import React from 'react';
import { BOX_IMAGE, CHECKOUT_URL, PURCHASE_ANCHOR } from '../data/content';
interface CTAButtonProps {
  label: string;
  sub?: string;
  target?: 'purchase' | 'checkout';
  className?: string;
}
export function CTAButton({
  label,
  sub,
  target = 'purchase',
  className = ''
}: CTAButtonProps) {
  const isCheckout = target === 'checkout';
  return <a href={isCheckout ? CHECKOUT_URL : PURCHASE_ANCHOR} {...isCheckout ? {
    rel: 'noopener'
  } : {}} className={`block w-full rounded-md bg-gold px-4 py-3 text-center font-body text-[0.92rem] font-extrabold uppercase leading-tight tracking-wide text-navy shadow-[0_5px_0_0_#A87C24] transition-colors duration-150 ease-out hover:bg-[#E0B257] active:translate-y-[3px] active:shadow-[0_2px_0_0_#A87C24] sm:text-lg ${className}`} data-id="element-27" data-mp="2g1o8al0szad7">
      {label}
      {sub ? <span className="mt-0.5 block font-body text-[0.66rem] font-semibold normal-case tracking-normal text-navy/80" data-id="element-28" data-mp="3cqdtolbn2l3x">
          {sub}
        </span> : null}
    </a>;
}
export function TrustLine({
  className = ''
}: {
  className?: string;
}) {
  return <p className={`text-center font-body text-[0.62rem] font-bold uppercase tracking-wide text-graphite sm:text-xs ${className}`} data-id="element-29" data-mp="1d9q67w3nokub">
      🛡️ 7-Day Money-Back Guarantee <span className="text-gold" data-id="element-30" data-mp="1n8o43pmz1qpz">•</span> ⚡
      Complete 6-in-1 System
    </p>;
}
interface BoxImageProps {
  className?: string;
  target?: 'purchase' | 'checkout';
}
export function BoxImage({
  className = '',
  target = 'purchase'
}: BoxImageProps) {
  const isCheckout = target === 'checkout';
  return <a href={isCheckout ? CHECKOUT_URL : PURCHASE_ANCHOR} {...isCheckout ? {
    rel: 'noopener'
  } : {}} className={`block ${className}`} data-id="element-31" data-mp="210cglu14uh7h">
      <img src={BOX_IMAGE} alt="RADIOLOGY VISUAL ATLAS™ complete 6-in-1 visual study system box set" className="mx-auto w-full drop-shadow-2xl" data-id="element-32" data-mp="25ydzoeyk6giy" />
    </a>;
}